// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"188":"9618db6bbff150ed51af","464":"4f27f499835369e95cb7","2248":"718815f8a30b8e5ec9c6","2976":"7fdc0c40d37340ba491f","4572":"f6d949842ad61d8dc52a","9384":"8a8f9614e2f1a843337f"}[chunkId] + ".js";
};